module.exports = __webpack_public_path__ + "static/media/error.530f30cb.svg";